// extracted by mini-css-extract-plugin
export default {"label":"Select_label__NPl7G","placeholder":"Select_placeholder__TrKbk","isFocused":"Select_isFocused__cP-GV"};